(function () {
  'use strict';

  function cleanNumber(value) {
    var number = Number(String(value == null ? '' : value).replace(/[^0-9.-]/g, ''));
    return isFinite(number) ? number : 0;
  }

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var modeButtons = toArray(root.querySelectorAll('[data-bs-mode]'));
    var modalModeButtons = toArray(root.querySelectorAll('[data-bs-modal-mode]'));
    var options = toArray(root.querySelectorAll('[data-bs-option]'));
    var stickyPrice = root.querySelector('[data-bs-sticky-price]');
    var stickySuffix = root.querySelector('[data-bs-sticky-suffix]');
    var stickyCaption = root.querySelector('[data-bs-sticky-caption]');
    var downInput = root.querySelector('[data-bs-down-input]');
    var termSelect = root.querySelector('[data-bs-term-select]');
    var taxCheckbox = root.querySelector('[data-bs-tax-checkbox]');
    var financeSummaryText = root.querySelector('[data-bs-finance-summary-text]');
    var openFinancingButtons = toArray(root.querySelectorAll('[data-bs-open-financing]'));
    var closeFinancingButtons = toArray(root.querySelectorAll('[data-bs-close-financing]'));
    var openCompareButtons = toArray(root.querySelectorAll('[data-bs-open-compare]'));
    var closeCompareButtons = toArray(root.querySelectorAll('[data-bs-close-compare]'));
    var financingModal = root.querySelector('[data-bs-financing-modal]');
    var compareModal = root.querySelector('[data-bs-compare-modal]');
    var modalPayment = root.querySelector('[data-bs-modal-payment]');
    var modalPaymentSuffix = root.querySelector('[data-bs-modal-payment-suffix]');
    var modalApr = root.querySelector('[data-bs-modal-apr]');
    var orderButton = root.querySelector('[data-bs-order-button]');
    var orderButtonText = root.querySelector('[data-bs-order-button-text]');
    var status = root.querySelector('[data-bs-status]');

    var captions = {
      cash: root.getAttribute('data-cash-caption') || 'Vehicle Price',
      finance: root.getAttribute('data-finance-caption') || 'Est. Financing'
    };
    var taxCaption = root.getAttribute('data-tax-caption') || '';
    var monthSuffix = root.getAttribute('data-month-suffix') || '/mo';
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en-US';
    var currentTerm = cleanNumber(root.getAttribute('data-term-default')) || 72;
    var fixedApr = Math.max(cleanNumber(root.getAttribute('data-apr-default')), 0);
    var downDefaultDollars = Math.max(cleanNumber(root.getAttribute('data-down-default')), 0);
    var estimatedTaxRate = Math.max(cleanNumber(root.getAttribute('data-tax-rate')), 0);
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var fallbackUrl = root.getAttribute('data-fallback-url') || '';
    var orderAction = root.getAttribute('data-order-action') || 'product_page';
    var depositEnabled = orderAction === 'depo_deposit';
    var depositAmountDollars = Math.max(cleanNumber(root.getAttribute('data-deposit-amount')), 0);
    var depositPaymentId = root.getAttribute('data-deposit-payment-id') || '';
    var depositPropertyLabel = root.getAttribute('data-deposit-property-label') || 'Refundable Deposit(per product)';
    var depositCheckoutUrl = root.getAttribute('data-deposit-checkout-url') || '/checkout';
    var depositClearCart = root.getAttribute('data-deposit-clear-cart') !== 'false';
    var orderLabel = root.getAttribute('data-order-label') || 'Add to Cart';
    var addingLabel = root.getAttribute('data-adding-label') || 'Adding…';
    var missingProductMessage = root.getAttribute('data-missing-product-message') || 'This model is not linked to a Shopify product.';
    var missingAddonMessage = root.getAttribute('data-missing-addon-message') || 'A paid option is not linked to a Shopify product.';
    var cartErrorMessage = root.getAttribute('data-cart-error-message') || 'We could not add this configuration to the cart.';
    var previousFocus = null;

    if (termSelect) termSelect.value = String(currentTerm);
    if (downInput) downInput.value = String(downDefaultDollars);
    if (modalApr) modalApr.textContent = fixedApr.toFixed(2).replace(/\.00$/, '') + '%';

    function formatMoney(cents) {
      var amount = Math.round(cleanNumber(cents)) / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return currency + ' ' + amount.toFixed(Number.isInteger(amount) ? 0 : 2);
      }
    }

    function formatDepositMoney(dollars) {
      var amount = Math.max(cleanNumber(dollars), 0);
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return currency + ' ' + amount.toFixed(2);
      }
    }

    function optionPrice(option) {
      return Math.max(Math.round(cleanNumber(option && option.getAttribute('data-cash-cents'))), 0);
    }

    function optionGroup(option) {
      return option ? option.getAttribute('data-bs-group') || '' : '';
    }

    function optionLabel(option) {
      return option ? option.getAttribute('data-label') || '' : '';
    }

    function optionGroupLabel(option) {
      return option ? option.getAttribute('data-group-label') || optionGroup(option) : '';
    }

    function isAvailable(option) {
      return Boolean(option) && !option.disabled && option.getAttribute('data-available') !== 'false';
    }

    function setSelected(option, selected) {
      if (!option) return;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }

    function normalizeSelections() {
      var groups = {};
      options.forEach(function (option) {
        var group = optionGroup(option);
        if (!groups[group]) groups[group] = [];
        groups[group].push(option);
      });

      Object.keys(groups).forEach(function (group) {
        var groupOptions = groups[group];
        var availableOptions = groupOptions.filter(isAvailable);
        var selected = availableOptions.filter(function (option) {
          return option.classList.contains('is-selected');
        });
        var keep = selected[0] || availableOptions[0] || null;

        groupOptions.forEach(function (option) {
          setSelected(option, option === keep);
        });
      });
    }

    function getMode() {
      return root.getAttribute('data-current-mode') === 'finance' ? 'finance' : 'cash';
    }

    function getSelectedOption(group) {
      return options.find(function (option) {
        return optionGroup(option) === group && option.classList.contains('is-selected');
      }) || null;
    }

    function getSelectedModel() {
      return getSelectedOption('model');
    }

    function getSelectedPackages() {
      return options.filter(function (option) {
        return optionGroup(option) !== 'model' && option.classList.contains('is-selected');
      });
    }

    function getSelectedAddonsTotal(excludedGroup) {
      return getSelectedPackages().reduce(function (total, option) {
        return optionGroup(option) === excludedGroup ? total : total + optionPrice(option);
      }, 0);
    }

    function getSubtotalCents() {
      var model = getSelectedModel();
      return optionPrice(model) + getSelectedAddonsTotal('');
    }

    function isTaxIncluded() {
      return Boolean(taxCheckbox && taxCheckbox.checked && estimatedTaxRate > 0);
    }

    function applyEstimatedTax(cents) {
      if (!isTaxIncluded()) return cents;
      return Math.round(cents * (1 + estimatedTaxRate / 100));
    }

    function downPaymentCents() {
      var dollars = cleanNumber(downInput ? downInput.value : downDefaultDollars);
      return Math.max(Math.round(dollars * 100), 0);
    }

    function calculateMonthly(totalCents) {
      var total = Math.max(cleanNumber(totalCents), 0);
      var down = Math.min(downPaymentCents(), total);
      var months = currentTerm > 0 ? currentTerm : 72;
      var principal = Math.max(total - down, 0);
      if (fixedApr <= 0) return principal / months;
      var monthlyRate = fixedApr / 100 / 12;
      return principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -months));
    }

    function optionDisplayCents(option) {
      var cash = optionPrice(option);
      if (getMode() === 'cash') return cash;

      if (optionGroup(option) === 'model') {
        return calculateMonthly(applyEstimatedTax(cash + getSelectedAddonsTotal('')));
      }

      var model = getSelectedModel();
      var group = optionGroup(option);
      var baseWithoutGroup = optionPrice(model) + getSelectedAddonsTotal(group);
      var withoutOption = calculateMonthly(applyEstimatedTax(baseWithoutGroup));
      var withOption = calculateMonthly(applyEstimatedTax(baseWithoutGroup + cash));
      return Math.max(withOption - withoutOption, 0);
    }

    function updateModeButtons() {
      var mode = getMode();
      modeButtons.forEach(function (button) {
        var active = button.getAttribute('data-bs-mode') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      modalModeButtons.forEach(function (button) {
        var active = button.getAttribute('data-bs-modal-mode') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateOptionPrices() {
      options.forEach(function (option) {
        var priceSlot = option.querySelector('[data-bs-option-price]');
        if (!priceSlot) return;
        priceSlot.textContent = formatMoney(optionDisplayCents(option));
        if (getMode() === 'finance') {
          var small = document.createElement('small');
          small.textContent = ' ' + monthSuffix;
          priceSlot.appendChild(small);
        }
      });
    }

    function updateFinanceSummary() {
      if (!financeSummaryText) return;
      financeSummaryText.textContent =
        fixedApr.toFixed(2).replace(/\.00$/, '') +
        '% APR, ' +
        formatMoney(downPaymentCents()) +
        ' down, ' +
        currentTerm +
        ' mo';
    }

    function updateSummary() {
      var mode = getMode();
      var total = applyEstimatedTax(getSubtotalCents());
      var display = mode === 'finance' ? calculateMonthly(total) : total;

      if (stickyPrice) stickyPrice.textContent = formatMoney(display);
      if (stickySuffix) stickySuffix.textContent = mode === 'finance' ? ' ' + monthSuffix : '';
      if (stickyCaption) {
        stickyCaption.textContent = (captions[mode] || captions.cash) + (isTaxIncluded() ? taxCaption : '');
      }
      if (modalPayment) modalPayment.textContent = formatMoney(display);
      if (modalPaymentSuffix) modalPaymentSuffix.textContent = mode === 'finance' ? monthSuffix : '';
      if (downInput) downInput.max = String(Math.max(Math.floor(total / 100), 0));
    }

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    function refresh() {
      updateModeButtons();
      updateOptionPrices();
      updateFinanceSummary();
      updateSummary();
    }

    function setMode(mode) {
      root.setAttribute('data-current-mode', mode === 'finance' ? 'finance' : 'cash');
      refresh();
    }

    function selectOption(option) {
      if (!isAvailable(option)) return;
      var group = optionGroup(option);
      options.forEach(function (item) {
        if (optionGroup(item) === group) setSelected(item, item === option);
      });
      setStatus('', false);
      refresh();
    }

    function activeModal() {
      if (financingModal && financingModal.getAttribute('aria-hidden') === 'false') return financingModal;
      if (compareModal && compareModal.getAttribute('aria-hidden') === 'false') return compareModal;
      return null;
    }

    function openModal(modal) {
      if (!modal) return;
      closeModal(activeModal(), false);
      previousFocus = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bs-order-modal-open');
      var panel = modal.querySelector('.bs-order__modal-panel');
      if (panel) panel.focus();
    }

    function closeModal(modal, restoreFocus) {
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      if (!activeModal()) document.body.classList.remove('bs-order-modal-open');
      if (restoreFocus !== false && previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    function openFinancingModal() {
      setMode('finance');
      openModal(financingModal);
    }

    function openCompareModal() {
      openModal(compareModal);
    }

    function focusableElements(modal) {
      if (!modal) return [];
      return toArray(modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) {
          return element.offsetParent !== null;
        });
    }

    function isCartOnlyFallback(url) {
      if (!url) return true;
      try {
        var parsed = new URL(url, window.location.origin);
        return /\/cart\/?$/.test(parsed.pathname);
      } catch (error) {
        return true;
      }
    }

    function quoteFallback(model) {
      if (!fallbackUrl || isCartOnlyFallback(fallbackUrl)) return false;
      var target = new URL(fallbackUrl, window.location.origin);
      target.searchParams.set('model', optionLabel(model));
      getSelectedPackages().forEach(function (option) {
        target.searchParams.set(optionGroupLabel(option), optionLabel(option));
      });
      target.searchParams.set('estimated_total', formatMoney(applyEstimatedTax(getSubtotalCents())));
      target.searchParams.set('payment_preference', getMode());
      window.location.assign(target.toString());
      return true;
    }

    function productPageRedirect(model) {
      var productUrl = model ? model.getAttribute('data-product-url') : '';
      var targetUrl = productUrl || fallbackUrl;
      if (!targetUrl || isCartOnlyFallback(targetUrl)) return false;

      var target = new URL(targetUrl, window.location.origin);
      var variantId = model.getAttribute('data-variant-id');
      if (variantId) target.searchParams.set('variant', variantId);
      target.searchParams.set('model', optionLabel(model));
      target.searchParams.set('payment_preference', getMode());
      target.searchParams.set('bs_config', '1');
      target.searchParams.set('bs_model', root.getAttribute('data-vehicle-title') || optionLabel(model));
      target.searchParams.set('bs_trim', optionLabel(model));
      target.searchParams.set('bs_payment', getMode() === 'finance' ? 'Finance' : 'Cash');
      target.searchParams.set('bs_estimated_total', formatMoney(applyEstimatedTax(getSubtotalCents())));

      if (getMode() === 'finance') {
        target.searchParams.set(
          'bs_financing',
          fixedApr.toFixed(2).replace(/\.00$/, '') +
            '% APR, ' +
            formatMoney(downPaymentCents()) +
            ' down, ' +
            currentTerm +
            ' months, ' +
            formatMoney(calculateMonthly(applyEstimatedTax(getSubtotalCents()))) +
            '/mo est.'
        );
      }

      getSelectedPackages().forEach(function (option) {
        target.searchParams.append('bs_option', optionGroupLabel(option) + '|' + optionLabel(option));
      });

      window.location.assign(target.toString());
      return true;
    }

    function configurationProperties(model, packages) {
      var properties = {};
      var modelPropertyLabel = model.getAttribute('data-group-label') || 'Model';
      properties['Configured Vehicle'] = root.getAttribute('data-vehicle-title') || optionLabel(model);
      properties[modelPropertyLabel] = optionLabel(model);
      packages.forEach(function (option) {
        properties[optionGroupLabel(option)] = optionLabel(option);
      });
      properties['Payment Preference'] = getMode() === 'finance' ? 'Financing estimate' : 'Cash';
      properties['Estimated Vehicle Total'] = formatMoney(applyEstimatedTax(getSubtotalCents()));
      if (getMode() === 'finance') {
        properties['Financing Estimate'] =
          fixedApr.toFixed(2).replace(/\.00$/, '') +
          '% APR, ' +
          formatMoney(downPaymentCents()) +
          ' down, ' +
          currentTerm +
          ' months';
      }
      if (isTaxIncluded()) properties['Estimated Tax Included'] = 'Yes';

      if (depositEnabled) {
        var modelPriceDollars = optionPrice(model) / 100;
        var depositPercentage = modelPriceDollars > 0
          ? (depositAmountDollars / modelPriceDollars) * 100
          : 0;

        properties[depositPropertyLabel] = formatDepositMoney(depositAmountDollars);
        properties['_part_payment_amount'] = depositAmountDollars.toFixed(1);
        properties['_pp_percentage'] = depositPercentage.toFixed(6);
        properties['_part_payment_id'] = String(depositPaymentId);
        properties['_flow'] = 'part_payment';
        properties['_deposit_charge_flow'] = 'no_charge';
        properties['_deposit_charge_ratio'] = '0.0';
        properties['_cart_flow'] = 'cart_v3';
      }

      return properties;
    }

    function cartEndpoint(path) {
      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      if (routeRoot.slice(-1) !== '/') routeRoot += '/';
      return routeRoot + path;
    }

    async function addConfigurationToCart() {
      var model = getSelectedModel();
      if (!model) {
        setStatus(missingProductMessage, true);
        return;
      }

      if (orderAction === 'quote') {
        if (!quoteFallback(model)) setStatus(missingProductMessage, true);
        return;
      }

      if (orderAction === 'product_page') {
        if (!productPageRedirect(model)) setStatus(missingProductMessage, true);
        return;
      }

      var modelVariantId = model.getAttribute('data-variant-id');
      if (!modelVariantId) {
        if (!quoteFallback(model)) setStatus(missingProductMessage, true);
        return;
      }

      if (depositEnabled && (depositAmountDollars <= 0 || !depositPaymentId)) {
        setStatus(cartErrorMessage + ' The refundable deposit plan is not configured.', true);
        return;
      }

      var packages = getSelectedPackages();
      if (!depositEnabled) {
        var missingPaidAddon = packages.find(function (option) {
          return option.getAttribute('data-requires-product') === 'true' && !option.getAttribute('data-variant-id');
        });
        if (missingPaidAddon) {
          setStatus(missingAddonMessage + ' (' + optionLabel(missingPaidAddon) + ')', true);
          return;
        }
      }

      var items = [{
        id: Number(modelVariantId),
        quantity: 1,
        properties: configurationProperties(model, packages)
      }];

      if (!depositEnabled) {
        packages.forEach(function (option) {
          var variantId = option.getAttribute('data-variant-id');
          if (!variantId) return;
          items.push({
            id: Number(variantId),
            quantity: 1,
            properties: {
              '_Configured for': optionLabel(model),
              '_Option group': optionGroupLabel(option)
            }
          });
        });
      }

      if (orderButton) orderButton.disabled = true;
      if (orderButtonText) orderButtonText.textContent = addingLabel;
      setStatus('', false);

      try {
        if (depositEnabled && depositClearCart) {
          var clearResponse = await fetch(cartEndpoint('cart/clear.js'), {
            method: 'POST',
            headers: { 'Accept': 'application/json' }
          });
          if (!clearResponse.ok) throw new Error(cartErrorMessage);
        }

        var response = await fetch(cartEndpoint('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
        var payload = await response.json().catch(function () { return {}; });
        if (!response.ok) {
          throw new Error(payload.description || payload.message || cartErrorMessage);
        }
        window.location.assign(depositEnabled ? depositCheckoutUrl : cartUrl);
      } catch (error) {
        setStatus(error && error.message ? error.message : cartErrorMessage, true);
        if (orderButton) orderButton.disabled = false;
        if (orderButtonText) orderButtonText.textContent = orderLabel;
      }
    }

    modeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(button.getAttribute('data-bs-mode'));
      });
    });

    modalModeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(button.getAttribute('data-bs-modal-mode'));
      });
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        selectOption(option);
      });
    });

    if (downInput) {
      downInput.addEventListener('input', refresh);
      downInput.addEventListener('change', function () {
        var maximum = cleanNumber(downInput.max);
        if (maximum > 0 && cleanNumber(downInput.value) > maximum) {
          downInput.value = String(maximum);
        }
        refresh();
      });
    }

    if (termSelect) {
      termSelect.addEventListener('change', function () {
        currentTerm = cleanNumber(termSelect.value) || currentTerm;
        refresh();
      });
    }

    if (taxCheckbox) taxCheckbox.addEventListener('change', refresh);
    if (orderButton) orderButton.addEventListener('click', addConfigurationToCart);

    openFinancingButtons.forEach(function (button) {
      button.addEventListener('click', openFinancingModal);
    });
    closeFinancingButtons.forEach(function (button) {
      button.addEventListener('click', function () { closeModal(financingModal, true); });
    });
    openCompareButtons.forEach(function (button) {
      button.addEventListener('click', openCompareModal);
    });
    closeCompareButtons.forEach(function (button) {
      button.addEventListener('click', function () { closeModal(compareModal, true); });
    });

    root.addEventListener('keydown', function (event) {
      var modal = activeModal();
      if (!modal) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(modal, true);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = focusableElements(modal);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    normalizeSelections();
    setMode(root.getAttribute('data-current-mode'));
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-bs-configurator]')) init(context);
    toArray(context.querySelectorAll('[data-bs-configurator]')).forEach(init);
    initReservationProperties();
  }

  function initReservationProperties() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('bs_config') !== '1') return;

    var properties = {
      'Configuration Source': 'Black Series Configurator',
      'Model': params.get('bs_model') || '',
      'Trim': params.get('bs_trim') || params.get('model') || '',
      'Payment Preference': params.get('bs_payment') || params.get('payment_preference') || '',
      'Configured Vehicle Price': params.get('bs_estimated_total') || ''
    };

    var financing = params.get('bs_financing');
    if (financing) properties['Financing Estimate'] = financing;

    params.getAll('bs_option').forEach(function (entry) {
      var separator = entry.indexOf('|');
      if (separator < 1) return;
      var label = entry.slice(0, separator).trim();
      var value = entry.slice(separator + 1).trim();
      if (label && value) properties[label] = value;
    });

    var forms = toArray(document.querySelectorAll('form[action*="/cart/add"]'));
    forms.forEach(function (form) {
      Object.keys(properties).forEach(function (label) {
        var value = properties[label];
        if (!value) return;
        var inputName = 'properties[' + label + ']';
        var existing = toArray(form.querySelectorAll('input[type="hidden"]')).find(function (input) {
          return input.name === inputName;
        });
        var input = existing || document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        input.value = value;
        input.setAttribute('data-bs-reservation-property', 'true');
        if (!existing) form.appendChild(input);
      });
    });

    if (!window.__blackSeriesReservationPropertiesObserver && document.documentElement) {
      window.__blackSeriesReservationPropertiesObserver = new MutationObserver(function () {
        initReservationProperties();
      });
      window.__blackSeriesReservationPropertiesObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
      window.setTimeout(function () {
        if (window.__blackSeriesReservationPropertiesObserver) {
          window.__blackSeriesReservationPropertiesObserver.disconnect();
          window.__blackSeriesReservationPropertiesObserver = null;
        }
      }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
